/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PredictedCategory } from './';
import {
    PredictedCategoryFromJSON,
    PredictedCategoryFromJSONTyped,
    PredictedCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CategoryPredictionResource
 */
export interface CategoryPredictionResource {
    /**
     * 
     * @type {PredictedCategory}
     * @memberof CategoryPredictionResource
     */
    category: PredictedCategory;
    /**
     * 
     * @type {number}
     * @memberof CategoryPredictionResource
     */
    probability: number;
}

/**
 * Check if a given object implements the CategoryPredictionResource interface.
 */
export function instanceOfCategoryPredictionResource(value: object): value is CategoryPredictionResource {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('probability' in value) || value['probability'] === undefined) return false;
    return true;
}

export function CategoryPredictionResourceFromJSON(json: any): CategoryPredictionResource {
    return CategoryPredictionResourceFromJSONTyped(json, false);
}

export function CategoryPredictionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryPredictionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'category': PredictedCategoryFromJSON(json['category']),
        'probability': json['probability'],
    };
}

export function CategoryPredictionResourceToJSON(value?: CategoryPredictionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': PredictedCategoryToJSON(value['category']),
        'probability': value['probability'],
    };
}

